var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 792 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}.cls-4{fill:#a19589;}.cls-5{fill:url(#radial-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.68,290.43c0,7.43,4.33,13.25,12.23,13.25,6.95,0,10.54-4.72,10.54-11.34,0-7.27-4.16-13.04-11.92-13.04-6.78,0-10.86,4.52-10.86,11.13m67.02,23.75c0-5.33-5.66-7.91-11.79-10.82-6.78-3.23-14.05-6.78-14.05-15.01,0-10.01,9.69-14.37,18.41-14.37,4.69,0,9.37,1.13,13.4,3.39v7.27c-3.88-3.07-8.56-4.84-13.56-4.84s-9.53,1.93-9.53,6.29c0,5.17,6.14,8.08,12.59,11.31,6.78,3.39,13.89,7.26,13.89,14.69,0,10.82-10.82,14.54-19.86,14.54-5.66,0-10.67-1.13-15.83-3.23v-7.43c5.34,2.9,11.95,4.67,16.15,4.67,4.51,.01,10.18-1.12,10.18-6.45m16.63-1.93v-44.73c0-7.27-.48-10.5-1.94-12.44l11.15-2.91v43.28l14.69-13.73s2.91-2.58,5.49-5.97h12.76c-.64,.16-2.9,.65-10.98,8.24l-13.73,12.92s8.24,9.7,16,18.26c5.97,6.46,10.49,8.39,13.24,8.39,.48,0,1.12-.15,1.61-.32-2.42,1.79-5.97,2.74-9.85,2.74-5,0-9.2-2.74-14.37-8.87-8.24-9.85-14.86-17.77-14.86-17.77v12.93c0,9.03,.48,10.49,1.29,12.59h-11.95c.97-2.59,1.45-3.56,1.45-12.6m-109.01-43.77c-2.74,5.5-4.36,13.24-4.36,19.7,0,9.84,1.46,18.73,5.66,28.1,7.1,15.83,19.87,24.88,37.3,24.88,4.85,0,9.21-.49,11.95-1.46,2.75-1.14,5.49-3.23,5.49-7.1,0-1.93-1.45-4.03-3.55-4.84-2.26-.81-4.2-.96-10.17-1.29-5.98-.33-8.08-.5-12.27-.81-6.62-.64-10.02-5.01-10.02-9.2,0-3.72,2.59-6.95,7.43-9.21-6.46-2.43-10.93-8.55-10.93-15.47,0-10.03,7.82-17.79,20.47-17.79,2.74,0,5.96,.64,8.7,1.45,2.27,.65,4.69,1.12,7.27,1.12,3.07,0,6.62-.15,9.53-.96v6.46c-1.62-.33-6.78-.65-9.53-.65,2.58,2.91,4.03,6.95,4.03,10.82,0,9.04-7.11,16.63-19.7,16.63-1.09,0-2.25-.06-3.62-.21-1.32,.26-2.5,.83-3.43,1.59-1.37,1.1-2,2.54-2,3.79,0,2.1,1.13,3.72,6.29,4.05l11.14,.64c10.83,.64,16.64,5.01,16.48,12.75-.33,8.89-7.43,15.35-24.55,15.35-4.52,0-10.5-.82-15.82-2.43-3.88-1.12-7.59-3.22-10.82-5.65,14.53,24.86,40.37,46.34,70.25,46.34,14.53,0,26.97-5.16,38.6-13.71,27.77-20.68,62.98-67.03,62.98-103.04,0-26.97-19.55-38.92-44.09-42.8-8.89-1.45-16.95-1.61-25.85-1.61-37.14,0-94.47,6.46-112.88,44.56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -1706.18,
    cy: 539.47,
    fx: -1706.18,
    fy: 539.47,
    r: 4.01,
    gradientTransform: "translate(54156.27 -16754.73) scale(31.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa71a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f99f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f58120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f26922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f15523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ef4723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef4223"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-416.30086,-665.7634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2449",
    transform: "translate(417.92125,667.15231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2384",
    className: "cls-3",
    d: "M375.02,269.48c0-30.18-21.44-42.02-46.6-45.98-8.92-1.26-18.57-1.58-27.49-1.58-35.98,0-95.86,5.69-115.6,46.29-3.02,6.16-5.1,14.69-5.1,21.64,0,25.74,14.08,53.32,32.68,72.99,17.48,18.51,36.58,26.5,56.96,26.5,15.76,0,28.98-5.29,41.08-14.14,27.86-20.7,64.06-68.14,64.06-105.73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2386"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect2409",
    className: "cls-5",
    x: 185.96,
    y: 223.91,
    width: 187.18,
    height: 161.16
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path2411",
    className: "cls-4",
    d: "M663.62,345.51h-10.49c.32-2.73,1.45-6.12,5.48-6.12,3.56,0,5,2.73,5,6.12m4.28,3.07c.05-.32,.06-.79,.06-1.16,0-6.52-2.28-11.26-9.35-11.26-6.13,0-9.84,4.68-9.84,11.14,0,7.26,3.23,11.94,10.98,11.94,3.7,0,5-.8,6.45-1.44v-4.04c-.97,.81-3.55,2.25-6.29,2.25-3.88,0-6.78-3.08-6.78-7.44h14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2413",
    className: "cls-4",
    d: "M644.9,358.76v-13.09c0-5.97-2.42-9.52-8.06-9.52-3.07,0-5.81,1.45-6.94,4.04h-.17v-3.55h-3.87v22.12h4.04v-10.18c0-5.49,1.77-9.36,6.46-9.19,3.56,.16,4.52,2.74,4.52,7.91v11.47h4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2415",
    className: "cls-4",
    d: "M620.29,329.38c0-1.29-.96-2.42-2.25-2.42s-2.42,1.13-2.42,2.42,1.13,2.25,2.42,2.25,2.25-.98,2.25-2.25m-.32,7.26h-4.04v22.12h4.04v-22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2417",
    className: "cls-4",
    d: "M611.94,358.58c-1.61-.49-1.93-1.61-1.93-3.06v-27.44h-4.19v27.92c0,2.09,.97,3.22,3.22,3.22,1.45,0,2.25-.33,2.9-.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon2419",
    className: "cls-4",
    points: "603.24 358.76 590.54 342.92 602.14 328.58 597.18 328.58 586.53 341.98 586.53 328.58 582.29 328.58 582.29 358.76 586.53 358.76 586.53 344.07 597.66 358.76 603.24 358.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2421",
    className: "cls-4",
    d: "M576.22,358.76v-13.09c0-5.97-2.42-9.52-8.07-9.52-3.05,0-5.32,1.3-6.77,3.71h-.16v-11.78h-4.04v30.67h4.04v-10.18c0-5.49,1.77-9.36,6.45-9.19,3.55,.16,4.52,2.74,4.52,7.91v11.47h4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2423",
    className: "cls-4",
    d: "M553.38,358.58v-3.39c-.64,.33-1.45,.81-2.74,.81-1.94,0-3.39-1.45-3.39-4.03v-12.12h5.49v-3.22h-5.49v-6.46l-4.04,1.29v5.17h-3.87v3.22h3.87v12.92c0,4.51,2.59,6.45,6.78,6.45,1.29,0,2.58-.33,3.39-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2425",
    className: "cls-4",
    d: "M536.18,329.38c0-1.29-1.13-2.42-2.42-2.42s-2.26,1.13-2.26,2.42,.96,2.25,2.26,2.25,2.42-.98,2.42-2.25m-.49,7.26h-4.03v22.12h4.03v-22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2427",
    className: "cls-4",
    d: "M526.18,358.76v-14.21c0-4.85-2.1-8.4-7.74-8.4-1.94,0-5.32,1.12-6.78,4.19-1.13-2.9-3.71-4.19-6.29-4.19-3.23,0-5.49,1.12-7.1,3.71v-3.23h-3.88v22.12h4.04v-11.14c0-4.2,1.77-8.23,5.81-8.23,3.39,0,4.03,3.39,4.03,6.12v13.25h4.04v-11.14c0-4.2,1.61-8.23,5.81-8.23,3.23,0,3.87,3.39,3.87,6.12v13.25h4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2429",
    className: "cls-4",
    d: "M490.88,350.35c0-6.12-5.17-7.91-9.68-10.01-.81-.32-1.61-.64-2.26-1.13-1.3-.81-2.26-1.93-2.26-3.55,0-3.22,3.22-4.19,5.97-4.19,2.15,0,4.48,.66,6.13,1.3l.65-3.55c-2.26-.81-4.85-1.3-6.95-1.3-6.13,0-10.65,2.91-10.65,8.23,0,5.81,5.65,7.27,9.69,9.21,2.25,.96,4.85,2.42,4.85,5.16,0,3.88-4.04,5.16-6.63,5.16-2.42,0-5.39-.76-7.1-1.45l-.32,3.87c1.76,.57,4.7,1.14,6.7,1.14,6.61,0,11.86-2.59,11.86-8.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon2431",
    className: "cls-4",
    points: "446.2 358.76 439.1 347.12 445.56 336.64 440.86 336.64 436.68 344.55 432.47 336.64 427.48 336.64 433.93 347.12 426.66 358.76 431.51 358.76 436.35 350.04 441.18 358.76 446.2 358.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2433",
    className: "cls-4",
    d: "M402.54,358.58c-1.62-.49-1.94-1.61-1.94-3.06v-27.44h-4.19v27.92c0,2.09,.96,3.22,3.23,3.22,1.45,0,2.42-.33,2.91-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2435",
    className: "cls-4",
    d: "M391.41,357.94v-13.18h-4.36v10.11c-1.13,.33-1.93,.49-4.84,.49-6.3,0-11.47-4.68-11.47-11.78s4.68-11.78,11.62-11.78c3.72,0,6.62,.97,8.39,2.1l.33-4.36c-2.59-.97-4.52-1.61-8.87-1.61-9.21,0-15.98,6.28-15.98,15.5,0,9.68,6.29,15.81,15.81,15.81,4.84,0,7.58-.8,9.36-1.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2437",
    className: "cls-4",
    d: "M468.71,347.61c0-6.62-3.88-11.46-10.5-11.46s-10.65,4.84-10.65,11.46,3.87,11.62,10.65,11.62c6.62,0,10.5-5.15,10.5-11.62m-4.36,0c0,4.04-1.45,8.4-6.14,8.4s-6.29-4.36-6.29-8.4,1.77-8.23,6.29-8.23c4.2,0,6.14,4.04,6.14,8.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2439",
    className: "cls-4",
    d: "M423.64,358.76c-.16-.66-.16-1.79-.16-4.37v-9.2c0-5.98-2.26-9.04-8.55-9.04-2.91,0-5,.81-7.1,2.09l.32,3.4c1.61-1.3,3.71-2.25,6.14-2.25,4.03,0,5,1.93,5,5.8-1.61-.16-2.58-.16-4.2-.16-4.19,0-9.69,1.78-9.69,7.26,0,4.85,3.07,6.95,7.75,6.95,3.71,0,5.64-2.1,6.45-3.4h.17v2.92h3.87Zm-4.36-8.57c0,3.23-1.77,5.81-5.81,5.81-1.78,0-3.71-1.3-3.71-3.72,0-3.87,5.01-4.18,7.11-4.18,.96,0,1.61,.16,2.42,.16v1.93h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsk);
export default __webpack_public_path__ + "static/media/gsk.7f325a8167135b1422f3054f1ab1cf0f.svg";
export { ForwardRef as ReactComponent };